/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View } from 'react-native';
import { isWeb } from '@global/screens';
import { parseDate, currency } from '@global/helpers';
import ItemDetail from '@components/global/ItemDetail';
import StatusBadge from '@components/global/StatusBadge';

// eslint-disable-next-line react/prop-types
const TargetBudgetPocket = ({ detailBudgetPocket = {} }) => {
  return (
    <View style={{ width: '100%' }}>
      <View
        style={{
          width: isWeb ? '45%' : '100%',
          paddingHorizontal: 20,
          paddingBottom: 20,
        }}>
        <ItemDetail
          name="Budget Name"
          value={detailBudgetPocket.name ? detailBudgetPocket.name : '-'}
        />
        <ItemDetail
          name="Budget Description"
          value={
            detailBudgetPocket?.description
              ? detailBudgetPocket.description
              : '-'
          }
        />
        <ItemDetail
          name="Budget Value"
          value={
            detailBudgetPocket?.value
              ? currency(detailBudgetPocket.value, true)
              : '-'
          }
        />
        <ItemDetail
          name="Budget Remaining"
          value={
            detailBudgetPocket?.budget_remaining
              ? detailBudgetPocket.budget_remaining
              : '-'
          }
        />
        <ItemDetail
          name="Periode"
          value={detailBudgetPocket?.periode ? detailBudgetPocket.periode : '-'}
        />
        <ItemDetail
          name="Status"
          value={<StatusBadge status={detailBudgetPocket.status} />}
        />
        <ItemDetail
          name="Last Updated, By"
          value={`${
            detailBudgetPocket.updated_at
              ? parseDate(detailBudgetPocket.updated_at)
              : '-'
          }${
            detailBudgetPocket?.updated_by?.name
              ? `, ${detailBudgetPocket.updated_by.name}`
              : ''
          }`}
        />
      </View>
    </View>
  );
};

export default TargetBudgetPocket;
